import React from 'react';
import { Modal, Button, Container, Row, Col,  Table, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import classes from './SpeciesClassModal.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import graphQLClientInstance from '../../axios-graphql-client';
import {
  getSearchClassesQuery,
  selectOptions,
  downloadBlob,
  downloadExcelWorksheetTitles,
  downloadExcelFileNames,
  API_URLS
} from '../../shared/utility';
import { generatexlx } from '../../exportXls';

import CloseButton from '../UI/CloseButton/CloseButton';

const SpeciesClassModal = (props: any) => {
  const { t } = useTranslation();
  const [data, setData] = React.useState<ISearchClassResponse|null>(null);

  const {
    classid
  } = props;

  React.useEffect(() => {
    if (classid) {
      setData(null);
      const values = {
        classCode: [{value: classid}],
        classCodeSelect: selectOptions.EXACT,
        className: [],
        classNameSelect: selectOptions.STARTS
      }
      graphQLClientInstance.post(API_URLS.GRAPHQL, getSearchClassesQuery(values, 1, 0))
      .then(res => {
        if (res.data?.data?.classesSearch?.data?.length) {
          setData(res.data.data.classesSearch.data[0]);
        }
      })
      .catch(err => {
        console.log(err);
      });
    }
  }, [classid]);

  const downloadClassExcel = async (species: any) => {
    let file = "";
    file = await generatexlx(
      species,
      [
        "species_id",
        "description"
      ],
      downloadExcelWorksheetTitles.SPECIES_CLASS_MODAL_WORKSHEET
    ).catch((err) => {
      console.log(err);
    });

    if (file) {
      const blob = new Blob([file], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      downloadBlob(blob, downloadExcelFileNames.SPECIES_CLASS_MODAL);
    }
  }

  return (
    <Modal centered show={props.show} onHide={() => props.setShow(false)} size="lg">
      <Modal.Header className={classes.header}>
        <CloseButton onClick={() => props.setShow(false)} />
        <Modal.Title>{t("class")}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={classes.body}>
        {data?(
          <Container>
            <Row>
              <Col md="3" className="mb-1">
                {t("class_code")}
              </Col>
              <Col md="9">
                {data?.classid}
              </Col>
              <Col md="3" className="mb-1">
                {t("class_name")}
              </Col>
              <Col md="9">
                {data?.classname}
              </Col>
              <Col md="3" className="mb-1">
                {t("remark")}
              </Col>
              <Col md="9">
                {data?.info}
              </Col>
              <Col md="3">
                {t("class")}
              </Col>
              <Col md="9">
                {data?.upovclass}
              </Col>
            </Row>
            <Container className={classes.collapsibleContent}>
              <Row className={classes.speciesIncludedHeader}>
                <Col md="11" >
                <span>
                    {t("species_include_same_class")}
                </span>
                </Col>
                <Col md="1" className="text-right">
                  <Button
                    id="downloadClassExcel"
                    onClick={() => { downloadClassExcel(JSON.parse(data?.species_object?data?.species_object:"[]")) }}
                    style={{color: '#000000', padding: '0 5px'}}
                    variant="link">
                      <FontAwesomeIcon icon={['fas', 'arrow-alt-circle-down']} />
                  </Button>
                </Col>
              </Row>
              {/* <Collapse in={openSpecies}> */}
                <Row>
                  <Col md="12" style={{padding: 0}}>
                    <Table striped hover size="sm">
                      <thead>
                        <tr>
                          <th>{t("species_code")}</th>
                          <th>{t("description")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {JSON.parse(data?.species_object)?.map((val: any, index: number) =>
                          <tr key={`species-${index}`}>
                            <td>{val?.species_id}</td>
                            <td>{val?.description}</td>
                          </tr>)}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              {/* </Collapse> */}
            </Container>
          </Container>
        ):<div className="text-center"><Spinner animation="border" variant="primary" /></div>}
      </Modal.Body>
    </Modal>
  );
};

export default SpeciesClassModal;

interface ISearchClassResponse {
  classid: string;
  classname: string;
  info: string;
  species_object: string;
  upovclass: string;
}
